// extracted by mini-css-extract-plugin
export default {"DataAvailabilityButton":"DataAvailabilityButton_DataAvailabilityButton__PYz-s","InfoIcon":"DataAvailabilityButton_InfoIcon__6d38E"};